import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker   } from 'antd';


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
	}
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

	render()

	{
	
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 
		 		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
					 <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Benefits of kidzonia App</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
					<ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   <li class="breadcrumb-item"><a href="/faqs/index">FAQs</a>
                           </li>
                           <li class="breadcrumb-item active">Benefits of kidzonia App 
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
            
		 
        
		 <div class="col s12 m12 ex-padd">             
            <div class="container">
			   <div class="col s12 m12 mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food">					
					<div class="diary bb ">
						<Collapse
							bordered={false}
							className="site-collapse-custom-collapse"
						  >
							<Panel header="How is kidzonia app useful to schools and parents?" key="1" className="site-collapse-custom-panel">
								 <p>kidzonia is an easy to use app that can be used on a Phone, Tab, Laptop or a Desktop to manage everything from Enquiries, Admissions, Fee payments, School Bus Tracker and to Communicate with parents. You can give custom permissions to your staff and monitor every update in the app from anywhere, anytime. Parents can get all updates about their child, pay fee, know about events and holidays, assignments and many more</p>
								 
							</Panel>
						  </Collapse>
					</div>
					<div class="diary bb ">
						<Collapse
							bordered={false}
							className="site-collapse-custom-collapse"
						  >
							<Panel header="I have two preschool/daycare branches. can I manage both these in kidzonia app?" key="1" className="site-collapse-custom-panel">
								 <p>Yes. in the same app, you can switch between all your branches and manage them using ‘Another school’ option under 'Setup & Settings'</p>
								 
							</Panel>
						  </Collapse>
					</div>
					<div class="diary bb ">
						<Collapse
							bordered={false}
							className="site-collapse-custom-collapse"
						  >
							<Panel header="How do I manage Admission enquiries in kidzonia App?" key="1" className="site-collapse-custom-panel">
								 <p>Staff can capture all the enquiry details directly in the app instead of a register so that you can see them from anywhere on your Phone. You can directly call the parents, set up follow reminders, make notes of the discussion with parents</p>
								 
							</Panel>
						  </Collapse>
					</div>
					<div class="diary bb ">
						<Collapse
							bordered={false}
							className="site-collapse-custom-collapse"
						  >
							<Panel header="Can I use kidzonia to manage all the Fee Bills & Receipts?" key="1" className="site-collapse-custom-panel">
								 <p>Ofcourse! You can create fee templates to suit your school's programs and then add fee invoices of multiple children and send them to any number of parents in one click. Parents can see fee bills, pay the fee and view/download the fee receipts in the app itself</p>
								 
							</Panel>
						  </Collapse>
					</div>
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
